export default __webpack_public_path__ + "d6a3c057c98136d6defe77934cac9316.svg";